import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function ResetPasswordPage() {
  const navigate = useNavigate()
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [ready, setReady] = useState(false)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const required = params.get('required') === 'true'
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) setReady(true)
      else if (required) setReady(true) // already logged in with temp password
      else setError('Invalid or expired reset link. Please request a new one.')
    })
  }, [])

  async function handleReset(e) {
    e.preventDefault()
    if (password !== confirmPassword) { setError('Passwords do not match'); return }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return }
    setLoading(true); setError('')

    const { error } = await supabase.auth.updateUser({ 
      password,
      data: { must_reset_password: false }
    })
    if (error) { setError(error.message); setLoading(false); return }

    setTimeout(() => navigate('/dashboard'), 2000)
    setLoading(false)
  }

  return (
    <div className="reset-page-root" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: '#202326', padding: 24
    }}>
      <style>{`
        @media (max-width: 768px) {
          .reset-page-root {
            padding: 14px !important;
          }
          .reset-card {
            padding: 28px 20px !important;
            border-radius: 12px !important;
          }
        }
      `}</style>
      <div className="reset-card" style={{ background: '#fff', borderRadius: 16, padding: '44px 40px', width: '100%', maxWidth: 420, boxShadow: '0 24px 80px rgba(0,0,0,0.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{
            width: 52, height: 52, borderRadius: 14,
            background: '#CBB17B',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 24, fontWeight: 700, color: '#202326',
            fontFamily: "'DM Sans', sans-serif", marginBottom: 12
          }}>C</div>
          <h1 style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 26, color: '#202326', marginBottom: 4 }}>Set New Password</h1>
          <p style={{ fontSize: 13, color: '#62615D' }}>Choose a strong password for your account</p>
        </div>

        {error && !ready && (
          <div style={{ background: '#FEE2E2', color: '#991B1B', padding: '12px 16px', borderRadius: 8, fontSize: 13, marginBottom: 16, textAlign: 'center' }}>
            {error}
            <br />
            <button onClick={() => navigate('/login')} style={{ color: '#CBB17B', background: 'none', border: 'none', cursor: 'pointer', fontSize: 13, fontWeight: 600, marginTop: 8 }}>
              Back to Login
            </button>
          </div>
        )}

        {ready && (
          <form onSubmit={handleReset}>
            <div style={{ marginBottom: 16 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#202326', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>New Password</label>
              <input
                type="password" placeholder="Minimum 8 characters"
                value={password} onChange={e => setPassword(e.target.value)}
                required style={{ width: '100%', padding: '12px 14px', borderRadius: 8, border: '1.5px solid #DED6CA', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
              />
            </div>
            <div style={{ marginBottom: 24 }}>
              <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#202326', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.5 }}>Confirm Password</label>
              <input
                type="password" placeholder="Re-enter your password"
                value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
                required style={{ width: '100%', padding: '12px 14px', borderRadius: 8, border: '1.5px solid #DED6CA', fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
              />
            </div>
            {error && <div style={{ background: '#FEE2E2', color: '#991B1B', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>{error}</div>}
            <button type="submit" disabled={loading} style={{
              width: '100%', padding: '13px', background: loading ? '#D4C9B5' : '#202326',
              color: '#CBB17B', border: 'none', borderRadius: 8, fontSize: 15,
              fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer'
            }}>
              {loading ? 'Updating…' : 'Update Password →'}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
